import request from '../request'

//MBTI测试
export function MBTI_index(params) {
  return request({ url: '/api/Evaluation.MBTI/index',method: 'post',data: params})
}
//添加MBTI测试结果
export function MebiMember_add(params) {
  return request({ url: '/api/Evaluation.MebiMember/add',method: 'post',data: params})
}
//查看自己的测评结果
export function lookDetailCengping(params) {
  return request({ url: '/api/Evaluation.MebiMember/lookDetailCengping',method: 'post',data: params})
}
//获取霍兰德测评题
export function Huolan_index(params) {
  return request({ url: '/api/Evaluation.Huolan/index',method: 'post',data: params})
}
//添加霍兰德测评结果
export function HuoMember_add(params) {
  return request({ url: '/api/Evaluation.HuoMember/add',method: 'post',data: params})
}
//查看自己的测评结果
export function lookHuolan(params) {
  return request({ url: '/api/Evaluation.HuoMember/lookHuolan',method: 'post',data: params})
}





// WEBPACK FOOTER //
// ./src/api/gw/ceping.js